import React from 'react';
import LoginForm from '../../components/shared/LoginForm';

const AgentLoginPage: React.FC = () => {
  return <LoginForm mode="agent" />;
};

export default AgentLoginPage;
